import { render, staticRenderFns } from "./ProductTypeDropdown.vue?vue&type=template&id=bcb18f34&"
import script from "./ProductTypeDropdown.vue?vue&type=script&lang=js&"
export * from "./ProductTypeDropdown.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports